import "./form-room-type.scss";

import { RoomTypeFormSchema } from "@factory/form/form.rule";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import { useFormContext } from "react-hook-form";
import { useParams } from "react-router-dom";

import InputDateControl from "../../../shared/ui/hook-form/input-date-control/input-date-control";

type InputFormSchema = RoomTypeFormSchema;
export function FormRoomType() {
  const { control, setValue } = useFormContext<RoomTypeFormSchema>();
  const { hotelId } = useParams();
  setValue("hotel", hotelId || "");
  // const { formElement: autocompleteHotel } = useAutocompleteHotel(
  //   getValues("hotel") || "",
  //   "hotel",
  //   "Hotel",
  //   "",
  //   (selectedHotel) => {
  //     setValue("hotel", selectedHotel?.value || "");
  //   }
  // );
  return (
    <div id="FormRoomType" className="room-type">
      {/* {autocompleteHotel} */}
      <InputControl<InputFormSchema>
        control={control}
        name="name"
        label="Name"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter name"
      />
      <InputDateControl<InputFormSchema>
        control={control}
        name="validFrom"
        label="Valid From"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter validFrom"
      />
      <InputDateControl<InputFormSchema>
        control={control}
        name="validUntil"
        label="Valid Until"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter validUntil"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="price"
        label="Price"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter price"
      />
    </div>
  );
}

export default FormRoomType;
